import distance from '@turf/distance';

import type { Coord, Units } from '@turf/helpers';

export type { Coord, Units };

function getCoordinateDistance(pt1: Coord, pt2: Coord, units: Units = 'miles'): number {
  return distance(pt1, pt2, { units });
}

export default getCoordinateDistance;
